import { render, staticRenderFns } from "./Coding.vue?vue&type=template&id=9e286584&scoped=true&"
import script from "./Coding.vue?vue&type=script&lang=js&"
export * from "./Coding.vue?vue&type=script&lang=js&"
import style0 from "./Coding.vue?vue&type=style&index=0&id=9e286584&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e286584",
  null
  
)

export default component.exports